import { compact } from 'lodash'
import { isMobile } from '@const/device'
import { Routes } from '@enums/Routes'
import { LinkItemProps } from '@templates/LinkItem'

export const FOOTER_LINKS_CONFIG: LinkItemProps[] = compact([
  {
    text: 'Школа экспертов',
    isSiteLink: true,
  },
  {
    text: 'Написать в поддержку',
    href: 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScKWVx4Qb0ARTpqH9rOfslBRPHrbbmtAjC8iYa8yGb1P8cscw/formResponse',
  },
  {
    text: 'Политика конфиденциальности',
    route: Routes.PRIVACY_POLICY,
  },
  isMobile && {
    text: 'Мой профиль',
    route: Routes.PROFILE,
  },
  isMobile && {
    text: 'Выход',
    isLogout: true,
  },
])
